import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { ArrowIcon } from '../../../../components/icon'
import { capitalizeFirstLetter } from '../../../../lib/utils'

import styles from './available-reqs.module.scss'

interface IJob {
  id: string
  links: { 'careersite-job-url': string }
  attributes: { title: string }
}

export default function AvailableReqs({ jobs }: { jobs: IJob[] }) {
  return (
    <div className={styles.root} id="jobs">
      <div className={styles.inner}>
        <h2 className={styles.heading}>
          <FormattedHTMLMessage
            defaultMessage="Klart du ska hänga med på vår fantastiska&nbsp;resa.&nbsp;Vi&nbsp;väntar&nbsp;på&nbsp;dig!"
            id="career.open-reqs.heading"
          />
        </h2>
        {jobs.length === 0 ? (
          <p className={styles.text}>
            <FormattedMessage
              defaultMessage="Vi har för närvarande inga lediga tjänster."
              id="career.open-reqs.no-positions"
            />
          </p>
        ) : (
          <table className={styles.table}>
            <tbody>
              <tr>
                <th className={styles.tableHeader}>
                  <FormattedMessage defaultMessage="Lediga tjänster" id="career.reqs.title" />
                </th>
              </tr>

              {jobs.map((job) => (
                <a href={job.links['careersite-job-url']} key={job.id} rel="noopener noreferrer" target="_blank">
                  <tr>
                    <td>
                      <ArrowIcon className={styles.arrow} theme="success" />
                      {capitalizeFirstLetter(job?.attributes?.title ?? '')}
                    </td>
                  </tr>
                </a>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}
